export const dataDeNascimentoDesabilitada = ({
  bloqueadaPelaTela,
  ehFormularioDeConjuge,
  ehCriacao,
  ehAcessoAdministrativo,
  habilitarCampoCpf,
  habilitarCampoNome,
}: {
  bloqueadaPelaTela: boolean;
  ehFormularioDeConjuge: boolean;
  ehCriacao: boolean;
  ehAcessoAdministrativo: boolean;
  habilitarCampoCpf: boolean;
  habilitarCampoNome: boolean;
}) => {
  if (bloqueadaPelaTela)
    return true;

  if (ehFormularioDeConjuge)
    return ehCriacao ? !habilitarCampoCpf : !habilitarCampoNome;

  if (ehAcessoAdministrativo && ehCriacao)
    return !habilitarCampoCpf;

  return !habilitarCampoNome;
};
